module.exports = __webpack_public_path__ + "static/8-f20bb6305f472b6bbc5d57cd58468e67.jpg";